import { WEBHOOK_EVENT_TYPES } from './webhook-event-types.js';
import * as payloads from './sample-payloads/index.js';
import { SCOPES } from '@atomicfi/constants-shared';
/** Master collection of webhook event configurations */
export const WEBHOOK_EVENTS = {
    [WEBHOOK_EVENT_TYPES.CONTINUOUS_ACCESS_TASK_FAILED]: {
        samplePayload: payloads.createContinuousAccessTaskFailedSamplePayload,
        scopes: [SCOPES.USER_LINK]
    },
    [WEBHOOK_EVENT_TYPES.TASK_STATUS_UPDATED]: {
        samplePayload: payloads.createTaskStatusUpdatedSamplePayload,
        scopes: [SCOPES.USER_LINK, SCOPES.EMPLOYER_LINK]
    },
    [WEBHOOK_EVENT_TYPES.TASK_AUTHENTICATION_STATUS_UPDATED]: {
        samplePayload: payloads.createTaskAuthenticationStatusUpdatedSamplePayload,
        scopes: [SCOPES.USER_LINK, SCOPES.EMPLOYER_LINK]
    },
    [WEBHOOK_EVENT_TYPES.DEPOSIT_SWITCH_REMOVED]: {
        samplePayload: payloads.createDepositSwitchRemovedSamplePayload,
        scopes: [SCOPES.USER_LINK]
    },
    [WEBHOOK_EVENT_TYPES.DEPOSIT_ACCOUNTS_SYNCED]: {
        samplePayload: payloads.createDepositAccountsSyncedSamplePayload,
        scopes: [SCOPES.USER_LINK]
    },
    [WEBHOOK_EVENT_TYPES.DEPOSIT_ACCOUNTS_ADDED]: {
        samplePayload: payloads.createDepositAccountsAddedSamplePayload,
        scopes: [SCOPES.USER_LINK]
    },
    [WEBHOOK_EVENT_TYPES.DEPOSIT_ACCOUNTS_UPDATED]: {
        samplePayload: payloads.createDepositAccountsUpdatedSamplePayload,
        scopes: [SCOPES.USER_LINK]
    },
    [WEBHOOK_EVENT_TYPES.DEPOSIT_ACCOUNTS_REMOVED]: {
        samplePayload: payloads.createDepositAccountsRemovedSamplePayload,
        scopes: [SCOPES.USER_LINK]
    },
    [WEBHOOK_EVENT_TYPES.LINKED_ACCOUNT_CONNECTED]: {
        samplePayload: payloads.createLinkedAccountConnectedSamplePayload,
        scopes: [SCOPES.USER_LINK, SCOPES.EMPLOYER_LINK]
    },
    [WEBHOOK_EVENT_TYPES.LINKED_ACCOUNT_DISCONNECTED]: {
        samplePayload: payloads.createLinkedAccountDisconnectedSamplePayload,
        scopes: [SCOPES.USER_LINK, SCOPES.EMPLOYER_LINK]
    },
    [WEBHOOK_EVENT_TYPES.EMPLOYER_FETCHED]: {
        samplePayload: payloads.createEmployerFetchedSamplePayload,
        scopes: [SCOPES.EMPLOYER_LINK]
    },
    [WEBHOOK_EVENT_TYPES.EMPLOYEE_ADDED]: {
        samplePayload: payloads.createEmployeeAddedSamplePayload,
        scopes: [SCOPES.EMPLOYER_LINK]
    },
    [WEBHOOK_EVENT_TYPES.EMPLOYEE_UPDATED]: {
        samplePayload: payloads.createEmployeeUpdatedSamplePayload,
        scopes: [SCOPES.EMPLOYER_LINK]
    },
    [WEBHOOK_EVENT_TYPES.EMPLOYEE_DEDUCTION_REQUEST]: {
        samplePayload: payloads.createEmployeeDeductionRequestsSamplePayload,
        scopes: [SCOPES.EMPLOYER_LINK]
    },
    [WEBHOOK_EVENT_TYPES.EMPLOYEES_FETCHED]: {
        samplePayload: payloads.createEmployeesFetchedSamplePayload,
        scopes: [SCOPES.EMPLOYER_LINK]
    },
    [WEBHOOK_EVENT_TYPES.EMPLOYER_DEDUCTION_TYPES_FETCHED]: {
        samplePayload: payloads.createEmployerDeductionTypesFetchedSamplePayload,
        scopes: [SCOPES.EMPLOYER_LINK]
    },
    [WEBHOOK_EVENT_TYPES.EMPLOYER_DOCUMENTS_FETCHED]: {
        samplePayload: payloads.createEmployerDocumentsFetchedSamplePayload,
        scopes: [SCOPES.EMPLOYER_LINK]
    },
    [WEBHOOK_EVENT_TYPES.EMPLOYMENT_SYNCED]: {
        samplePayload: payloads.createEmploymentSyncedSamplePayload,
        scopes: [SCOPES.USER_LINK]
    },
    [WEBHOOK_EVENT_TYPES.EMPLOYMENT_UPDATED]: {
        samplePayload: payloads.createEmploymentUpdatedSamplePayload,
        scopes: [SCOPES.USER_LINK]
    },
    [WEBHOOK_EVENT_TYPES.INCOME_SYNCED]: {
        samplePayload: payloads.createIncomeSyncedSamplePayload,
        scopes: [SCOPES.USER_LINK]
    },
    [WEBHOOK_EVENT_TYPES.INCOME_UPDATED]: {
        samplePayload: payloads.createIncomeUpdatedSamplePayload,
        scopes: [SCOPES.USER_LINK]
    },
    [WEBHOOK_EVENT_TYPES.IDENTITY_SYNCED]: {
        samplePayload: payloads.createIdentitySyncedSamplePayload,
        scopes: [SCOPES.USER_LINK]
    },
    [WEBHOOK_EVENT_TYPES.IDENTITY_UPDATED]: {
        samplePayload: payloads.createIdentityUpdatedSamplePayload,
        scopes: [SCOPES.USER_LINK]
    },
    [WEBHOOK_EVENT_TYPES.PAYROLL_DATA_FETCHED]: {
        samplePayload: payloads.createPayrollDataFetchedSamplePayload,
        scopes: [SCOPES.USER_LINK]
    },
    [WEBHOOK_EVENT_TYPES.STATEMENTS_SYNCED]: {
        samplePayload: payloads.createStatementsSyncedSamplePayload,
        scopes: [SCOPES.USER_LINK]
    },
    [WEBHOOK_EVENT_TYPES.STATEMENTS_ADDED]: {
        samplePayload: payloads.createStatementsAddedSamplePayload,
        scopes: [SCOPES.USER_LINK]
    },
    [WEBHOOK_EVENT_TYPES.TIMESHEETS_SYNCED]: {
        samplePayload: payloads.createTimesheetsSyncedSamplePayload,
        scopes: [SCOPES.USER_LINK]
    },
    [WEBHOOK_EVENT_TYPES.TIMESHEETS_ADDED]: {
        samplePayload: payloads.createTimesheetsAddedSamplePayload,
        scopes: [SCOPES.USER_LINK]
    },
    [WEBHOOK_EVENT_TYPES.TAXES_SYNCED]: {
        samplePayload: payloads.createTaxesSyncedSamplePayload,
        scopes: [SCOPES.USER_LINK]
    },
    [WEBHOOK_EVENT_TYPES.TAXES_ADDED]: {
        samplePayload: payloads.createTaxesAddedSamplePayload,
        scopes: [SCOPES.USER_LINK]
    },
    [WEBHOOK_EVENT_TYPES.EARN_USER_DATA]: {
        samplePayload: payloads.createEarnUserDataSamplePayload,
        scopes: [SCOPES.USER_LINK]
    },
    [WEBHOOK_EVENT_TYPES.TASK_WORKFLOW_FINISHED]: {
        samplePayload: payloads.createTaskWorkflowFinishedSamplePayload,
        scopes: [SCOPES.USER_LINK]
    },
    [WEBHOOK_EVENT_TYPES.CONVERSION_OPPORTUNITY]: {
        samplePayload: payloads.createConversionOpportunitySamplePayload,
        scopes: [SCOPES.USER_LINK]
    },
    [WEBHOOK_EVENT_TYPES.TASK_STATUS_PATCHED]: {
        samplePayload: payloads.createTaskStatusPatchedSamplePayload,
        scopes: [SCOPES.USER_LINK, SCOPES.EMPLOYER_LINK]
    },
    [WEBHOOK_EVENT_TYPES.TEST]: {
        samplePayload: payloads.createTaskStatusUpdatedSamplePayload,
        scopes: [SCOPES.USER_LINK, SCOPES.EMPLOYER_LINK]
    },
    [WEBHOOK_EVENT_TYPES.PAYROLL_RUNS_FETCHED]: {
        samplePayload: payloads.createPayrollRunsFetchedSamplePayload,
        scopes: [SCOPES.EMPLOYER_LINK]
    },
    [WEBHOOK_EVENT_TYPES.PAYROLL_RUNS_ADDED]: {
        samplePayload: payloads.createPayrollRunsAddedSamplePayload,
        scopes: [SCOPES.EMPLOYER_LINK]
    },
    [WEBHOOK_EVENT_TYPES.PAYROLL_RUNS_UPDATED]: {
        samplePayload: payloads.createPayrollRunsUpdatedSamplePayload,
        scopes: [SCOPES.EMPLOYER_LINK]
    },
    [WEBHOOK_EVENT_TYPES.PII_DATA_DELETED]: {
        samplePayload: payloads.createPiiDataDeletedSamplePayload,
        scopes: [SCOPES.USER_LINK]
    },
    [WEBHOOK_EVENT_TYPES.COMPANY_UPDATED]: {
        samplePayload: payloads.companyUpdatedSamplePayload,
        scopes: [SCOPES.USER_LINK]
    },
    [WEBHOOK_EVENT_TYPES.COMPANY_CREATED]: {
        samplePayload: payloads.companyCreatedSamplePayload,
        scopes: [SCOPES.USER_LINK]
    },
    [WEBHOOK_EVENT_TYPES.COMPANY_DELETED]: {
        samplePayload: payloads.companyDeletedSamplePayload,
        scopes: [SCOPES.USER_LINK]
    }
};
//# sourceMappingURL=webhook-events.js.map